/* eslint-disable no-unused-expressions */
/* eslint-disable no-return-await */
/* eslint-disable no-use-before-define */
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { isCountryPeruOrColombia } from '@constants/regions';
import { isFullProfile, moneyFormat } from '@helpers';
import { setTransactionInProgress } from '@store/transactions/actions';
import { showError } from '@store/logged/actions';
import { doFundsOut, doCashOut } from '@services/funds-out-service';
import { SUCCESS_FUNDS_OUT, FUNDS_OUT } from '@constants/routes';
import { isAllowed } from '@helpers/auth';
import { useAuth } from '@hooks';
import { withdrawalLimit } from '@constants/documentation';
import { setMerchantBalance } from '@store/andes/actions';
import * as Routes from '@constants/routes';

export const useFundsOut = () => {
  const { merchant, isSeller } = useAuth();
  const bankAccount = useSelector((state) =>
    state.login.merchant?.bank_accounts?.find((el) => el.enabled)
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const withdraw = async (amount, dayLimit) => {
    const useDoCashOut = isCountryPeruOrColombia;
    let async = useDoCashOut;
    let doMoneyWithdrawal = useDoCashOut ? doCashOut : doFundsOut;
    if (!useDoCashOut) {
      if (isAllowed('WITHDRAW_LARGE_AMOUNT') && amount > withdrawalLimit.fullProfile) {
        async = true;
        doMoneyWithdrawal = doCashOut;
      } else if (dayLimit === withdrawalLimit.fullProfile && dayLimit < amount) {
        return dispatch(
          showError({
            message: t('paymentsFoundsOut.errors.errorWithDocument', {
              money: moneyFormat(withdrawalLimit.fullProfile, true),
            }),
          })
        );
      }
      if (!isAllowed('WITHDRAW_LARGE_AMOUNT') && dayLimit < amount) {
        return dispatch(
          showError({
            message: t('paymentsFoundsOut.errors.errorWithoutDocument', {
              money: moneyFormat(withdrawalLimit.incompleteProfile, true),
            }),
          })
        );
      }
    } else if (dayLimit === withdrawalLimit.fullProfile && dayLimit < amount) {
      return dispatch(
        showError({
          message: t('paymentsFoundsOut.errors.errorWithDocument', {
            money: moneyFormat(withdrawalLimit.fullProfile, true),
          }),
        })
      );
    }

    dispatch(setTransactionInProgress(true));
    doMoneyWithdrawal(merchant._id, amount)
      .then(() => history.push(SUCCESS_FUNDS_OUT, { async }))
      .catch((error) => {
        if (error.status === 403 && error.message.code === '1000') {
          history.push(FUNDS_OUT);
        } else {
          history.push(Routes.WITHDRAW_ERROR, {
            fraudError: error?.fraud_assesment_code === 1000,
            errorType: error?.error_type,
          });
        }
      })
      .finally(() => {
        dispatch(setMerchantBalance(null));
        return dispatch(setTransactionInProgress(false));
      });
  };

  const getDayLimit = useCallback(
    () =>
      isFullProfile(merchant.document_status, isSeller())
        ? withdrawalLimit.fullProfile
        : withdrawalLimit.incompleteProfile,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [merchant]
  );

  return {
    bankAccount,
    withdraw,
    getDayLimit,
  };
};
